/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerGoCampaign_Counties.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for GoCampaign Counties
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Saturday, October 26, 2019 - 03:25:47 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      10/26/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    GOCAMPAIGNCOUNTY_LIST_CONTAINER_LOADED,
    GOCAMPAIGNCOUNTY_LIST_CONTAINER_UNLOADED,
    GOCAMPAIGNCOUNTY_LIST_TABLE_LOADED,
    GOCAMPAIGNCOUNTY_LIST_TABLE_UNLOADED,

    GOCAMPAIGNCOUNTY_SELECT_ROW,
    GOCAMPAIGNCOUNTY_ADD,
    GOCAMPAIGNCOUNTY_EDIT,
    GOCAMPAIGNCOUNTY_DELETE,
    GOCAMPAIGNCOUNTY_OPEN_WARNING,
    GOCAMPAIGNCOUNTY_CLOSE_WARNING,
    GOCAMPAIGNCOUNTY_DELETE_DISABLE,

    GOCAMPAIGNCOUNTY_EDIT_CONTAINER_LOADED,
    GOCAMPAIGNCOUNTY_EDIT_CONTAINER_UNLOADED,
    GOCAMPAIGNCOUNTY_EDIT_FORM_LOADED,
    GOCAMPAIGNCOUNTY_EDIT_FORM_UNLOADED,
    GOCAMPAIGNCOUNTY_EDIT_DATA_LOAD,
    GOCAMPAIGNCOUNTY_EDIT_CONTAINER_SUBMIT,
    GOCAMPAIGNCOUNTY_EDIT_CONTAINER_CANCEL,

    GOCAMPAIGNCOUNTY_UPDATE_VALUE
} from '../constants/actionTypeGoCampaign_Counties';

const defaultState = {
    refreshList: false,
    danger: false,
    gocampaigncountyid: 0,
    countryid: 0,
    stateid: 0,
    name: '',
    countycode: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case GOCAMPAIGNCOUNTY_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                gocampaigncounties: action.payload[0] ? action.payload[0].records : null,
                countries: action.payload[1] ? action.payload[1].records : null,
                states: action.payload[2] ? action.payload[2].records : null,
            }
        case GOCAMPAIGNCOUNTY_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case GOCAMPAIGNCOUNTY_SELECT_ROW:
            return {
                ...state,
                gocampaigncountyid: action.id
            }
        case GOCAMPAIGNCOUNTY_ADD:
            return {
                ...state
            }
        case GOCAMPAIGNCOUNTY_EDIT:
            return {
                ...state,
                gocampaigncountyid: action.id
            }
        case GOCAMPAIGNCOUNTY_DELETE:
            return {
                ...state,
                gocampaigncountyid: null
            }
        case GOCAMPAIGNCOUNTY_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case GOCAMPAIGNCOUNTY_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case GOCAMPAIGNCOUNTY_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case GOCAMPAIGNCOUNTY_EDIT_CONTAINER_LOADED:
        case GOCAMPAIGNCOUNTY_EDIT_DATA_LOAD:
            return {
                ...state,
                gocampaigncountyid: action.payload[0] ? action.payload[0].gocampaigncountyid : 0,
                countryid: action.payload[0] ? action.payload[0].countryid : 0,
                country: action.payload[1] ? action.payload[1].name : action.payload[0] ? action.payload[0].country : '',
                stateid: action.payload[0] ? action.payload[0].stateid : 0,
                state: action.payload[2] ? action.payload[2].name : action.payload[0] ? action.payload[0].state : '',
                name: action.payload[0] ? action.payload[0].name : '',
                countycode: action.payload[0] ? action.payload[0].countycode : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case GOCAMPAIGNCOUNTY_UPDATE_VALUE:
            return {
                ...state,
                [action.key]: action.value
            }
        case GOCAMPAIGNCOUNTY_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case GOCAMPAIGNCOUNTY_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case GOCAMPAIGNCOUNTY_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case GOCAMPAIGNCOUNTY_LIST_CONTAINER_UNLOADED:
        case GOCAMPAIGNCOUNTY_LIST_TABLE_UNLOADED:
        case GOCAMPAIGNCOUNTY_EDIT_CONTAINER_UNLOADED:
        case GOCAMPAIGNCOUNTY_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerGoCampaign_Counties.js